import React, { useState } from "react";
import { bemClassName } from 'bem-components-connector'

import { getAnimationDurationClassName } from "@common-helpers/get-animation-duration-class-name"


import Logo from './img/logo.svg'
import { Button } from "@common-ui/btn"

import CardIcon from './img/card-icon.svg'
import { PaySection } from './components/pay-section'


import './style.scss'
import poweredByStripe from './img/powered-by-stripe.svg';
import axios from "axios";
import { componentMount } from "@common-hooks/component-mount";
import { sendEventToArbitration } from "@common-helpers/arbitration-helper"
import { Footer } from '@common-layout-components/footer'
import { Modal } from '@common-components/modal'
import { sendMetrik } from "@common-helpers/yaMetrik";

// const {
//     advantageList
// } = options

const animationDurationClassName = getAnimationDurationClassName()


export const CardPay = ({ nextRout, nextPageId, answersOnQuestions }) => {

    const block = bemClassName('payment-page')

    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const openModalHandler = async (event) => {
        event.preventDefault();

        const { data } = await axios.get(event.target.href, {
            headers: {
                'x-requested-with': 'XMLHttpRequest',
            },
            responseType: 'html',
        });

        setModalOpen(true);
        setModalContent(data);
        document.querySelector('.modal_open').scrollTop = 0;
    }

    componentMount(() => {
        sendEventToArbitration(nextPageId - 1, 'PP');
        sendMetrik('reachGoal', 'payment_page');
    })


    return (<div className={`content package_pay package ${block()} ${animationDurationClassName}`} >

        <div className={'logo-cont'}>
            <img src={Logo} alt="" />
        </div>


        <div className={`content__inner`}>

            <div className={`${block('wrapper')}`} >

                <div className={block('container')}>

                    <div className={block('header')}>
                        <img src={CardIcon} alt="" />

                        <div className="header-txt">
                            <h1>
                                Credit Card
                                </h1>
                            <p>
                                Masterсard, Maestro, Visa
                                </p>
                        </div>
                    </div>


                    <PaySection {...{ block, nextRout, nextPageId, openModalHandler }} />
                </div>

            </div>

            <div className={`${block('stripe-img')}`} >
                <img src={poweredByStripe} alt="" />
            </div>

        </div>

        <Footer theme={'pink'}>By using this site, you consent to the use of cookies to help us make it better and you are also agree to our <a href={'/privacy'} onClick={openModalHandler}>privacy policy</a>.</Footer>
        <Modal
            isOpen={modalOpen}
            openHandler={setModalOpen}
            theme={'big'}
        >
            {modalContent}
        </Modal>

    </div>)

}

